var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96407 7.69928L1.12406 0.79472C1.10096 0.776534 1.0732 0.765233 1.04397 0.762113C1.01473 0.758993 0.985214 0.764182 0.958797 0.777083C0.93238 0.789985 0.910138 0.810075 0.894625 0.835048C0.879111 0.86002 0.870956 0.888862 0.871096 0.918261V2.43409C0.871096 2.53018 0.916198 2.62234 0.990714 2.68117L8.05017 8.19345L0.990714 13.7057C0.914237 13.7645 0.871096 13.8567 0.871096 13.9528V15.4686C0.871096 15.6 1.02209 15.6726 1.12406 15.5922L9.96407 8.68761C10.0392 8.629 10.1 8.55403 10.1418 8.4684C10.1836 8.38277 10.2053 8.28874 10.2053 8.19345C10.2053 8.09816 10.1836 8.00412 10.1418 7.91849C10.1 7.83286 10.0392 7.75789 9.96407 7.69928Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLine);
export default __webpack_public_path__ + "static/media/openLine.99324ee6641bb1aeefdafbc55e98f648.svg";
export { ForwardRef as ReactComponent };